import React from 'react'
import PropTypes from 'prop-types'
import { HorizontalRule, Icon, Button, Flex, Copy, Hide } from '@elparking/components'
import Timetable from 'commons/js/components/Timetable'

import PriceContainer from './PriceContainer'

import { Events, trackEvent } from 'commons/js/services/analytics'

import {
    Container,
    DistanceContainer,
    ButtonContainter,
    InfoContainter,
    DistanceText,
} from './layout'
import { FormattedMessage } from 'react-intl'

const StationCard = React.memo(({
    id,
    isSelected,
    name,
    originalPrice,
    address,
    timetables,
    webPrice,
    distance,
    url,
    trackEvent,
}) => (
    <a rel='noopener noreferrer' href={url} target='_blank' data-test={`vehicle-inspection-station-card-${id}`} onClick={() => trackEvent(Events.vehicleInspectionSearchSelectStation, id)}>
        <Container
          background={ isSelected ? 'main20' : 'white'}
          w='100%'
          flexDirection={['column', 'row']}>
            <PriceContainer
              isSelected={isSelected}
              originalPrice={originalPrice}
              distance={distance}
              webPrice={webPrice}
            />
            <InfoContainter w='100%' p='0.5em'>
                <Copy textAlign='left' padding='0' color='main' fontWeight='medium' transform='uppercase' fontSize='small'>
                    {name}
                </Copy>
                <Flex justifyContent='space-between'>
                    <Copy.clamp lines='1' padding='0' textAlign='left' color='gray' fontWeight='regular' fontSize='small'>
                        {address}
                    </Copy.clamp>
                    <Hide xs sm>
                        <DistanceContainer>
                            <DistanceText distance={distance} />
                        </DistanceContainer>
                    </Hide>
                </Flex>
                <HorizontalRule background='lightGray40' m='0.5em 0' />
                <Copy textAlign='left' padding='0 0 1em 0' color='gray' fontWeight={['medium', 'regular']} fontSize='xSmall'>
                    {timetables && <Timetable timetables={timetables} />}
                </Copy>
                <ButtonContainter>
                    <Button height='2.3em' lineHeight='1em' padding='0.5em 1em' dataTest={`see-more-button-${id}`}>
                        <Copy as='span' fontSize='xSmall' color='white' padding='0 1em 0 0'>
                            <FormattedMessage defaultMessage='Ver más' />
                        </Copy>
                        <Icon color='white' type='right' />
                    </Button>
                </ButtonContainter>
            </InfoContainter>
        </Container>
    </a>
))

StationCard.propTypes = {
    trackEvent: PropTypes.func,
    id: PropTypes.number,
    isSelected: PropTypes.bool,
    timetables: PropTypes.object,
    distance: PropTypes.number.isRequired,
    originalPrice: PropTypes.object,
    webPrice: PropTypes.object.isRequired,
    name: PropTypes.string.isRequired,
    address: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
}

StationCard.defaultProps = {
    trackEvent,
    isSelected: false,
    url: '#',
}

export default StationCard
